import React from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TrackNameProps {
  name: string;
  imageUrl: string | null;
}

/** The artwork and the title of a track. */
const TrackNameComponent: React.FC<TrackNameProps> = ({ name, imageUrl }) => (
  <>
    {imageUrl !== null ? <img className={styles.artwork} src={imageUrl} alt="" /> : <span className={styles.artwork} />}
    <span>{name}</span>
  </>
);

export const TrackName = TypedMemo(TrackNameComponent);
